'use strict';

const VideoHelper = (($) => {

    const NAME = 'videoHelper';
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {}

    class VideoHelper {

        // totalWidth = 0;

        static get Default() {
            return Default
        }

        constructor($element, config) {
            this._config = $.extend({}, Default, config);
            this.$element = $element;
            this.$container = $element.parent();
            this.video = $element[0];

            this.init();
            this.addEventListeners();

            var _ = this;
        }

        init() {
            if (!this.video.autoplay) {
                console.log('add button');
                this.$container.append('<button class="video-play-button"></button>');
            }
            // console.log(this.$element.attr('autoplay'));
            // this.$element[0].play();
        }

        addEventListeners() {
            var _self = this;

            if (!this.video.autoplay) {
                this.$container.on('click', function (e) {
                    _self.handlePlay()
                });
            }

        }

        handlePlay(e) {
            // this.video.play();
            // this.$element.attr('controls', true);
            // this.$container.find('.video-play-button').remove();

            if (this.video.paused) {
                this.video.play();
                this.$element.attr('controls', true);
                this.$container.addClass('playing');
            } else {
                this.video.pause();
                this.$element.attr('controls', false);
                this.$container.removeClass('playing');
            }
        }


        static _jQueryInterface(config) {
            config = config || {};
            return this.each(() => {
                let $this = $(this);
                let _config = $.extend(
                    {},
                    VideoHelper.Default,
                    $this.data(),
                    typeof config === 'object' && config
                );

                new VideoHelper(this, _config)
            })
        }
    }

    $.fn[NAME] = VideoHelper._jQueryInterface;
    $.fn[NAME].Constructor = VideoHelper;
    $.fn[NAME].noConflict = () => {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return VideoHelper._jQueryInterface
    };

    return VideoHelper;

})(jQuery);

export default VideoHelper;